import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import Places from 'constants/places'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import useUserHasLoyaltyBenefit from 'loyalty/hooks/useUserHasLoyaltyBenefit'
import { useIntl } from 'react-intl'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  gravity: 'south',
}

const FILTERS: App.OfferListFilters = {
  destinations: [Places.Anywhere.id],
  loyalty: ['Free Room Upgrade'],
}

const OFFERS_LINK = `/search?${getSearchQueryFromFilter(FILTERS)}`

interface Props {
  image: App.Image
}

function LandingPageLoyaltyStayUpgradeBenefitsModal(props: Props) {
  const { image } = props
  const userHasUpgradesAvailable = useUserHasLoyaltyBenefit('hotel_upgrade')
  const intl = useIntl()

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'Z7utixZ04puxa0uWi7eJ',
        defaultMessage: 'Upgrade your stay',
        description: 'Heading title for the stay upgrade benefit details modal',
      })}
      />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="hotel_upgrade" />
            <BodyText variant="large">
              {intl.formatMessage({
                id: 'JqN5_k8mWNjMuA2XfoQr',
                defaultMessage: 'Upgrade your stay with free room or package upgrades at select hotels.',
                description: 'Description of the stay upgrade benefit in the details modal',
              })}
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">{intl.formatMessage({
                id: 'pDDtwdmaQbKykXjJ8OCm',
                defaultMessage: 'How it works',
                description: 'Section heading explaining how the stay upgrade benefit works',
              })}
              </Heading>
              <BodyText variant="large">
                {intl.formatMessage({
                  id: 'Tff29A1HBiXlN1wOZl8Y',
                  defaultMessage: 'When browsing for a hotel, you will been shown which offers are eligible for a room and package upgrades. Once applied the room or package will automatically be upgraded at no additional cost.',
                  description: 'Explanation of how the room upgrade benefit is applied during hotel browsing',
                })}
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: '4It9GoHbHmqCHGoNPqIi',
            defaultMessage: 'View offers',
            description: 'Button to view hotel offers eligible for room upgrades',
          }),
          to: OFFERS_LINK,
        }}
        isPrimaryActionHidden={!userHasUpgradesAvailable}
      />
    </ModalBase>
  )
}

export default LandingPageLoyaltyStayUpgradeBenefitsModal
